import { render, staticRenderFns } from "./recommended-listing-filter-modal.vue?vue&type=template&id=4ede5124&scoped=true"
import script from "./recommended-listing-filter-modal.vue?vue&type=script&lang=js"
export * from "./recommended-listing-filter-modal.vue?vue&type=script&lang=js"
import style0 from "./recommended-listing-filter-modal.vue?vue&type=style&index=0&id=4ede5124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ede5124",
  null
  
)

export default component.exports